import calculate from "src/calculator/calculate";
import { getTaxRate, yearRange } from "../utils";
import SpendingChart from "./Charts/SpendingChart";
import Header from "./Report/Header";
import { getSpendingItemOverYears } from "./Spending/calculate";
import { Client, Income, ScenarioSettings } from "src/types";
import { useUser } from "src/hooks/useUser";

interface MapChartProps {
  settings: ScenarioSettings;
  client: Client;
  print?: boolean;
}

const SpendChart = ({ settings, client, print }: MapChartProps) => {
  const startYear = new Date().getFullYear();
  const spending = client.spending;
  const currentYear = new Date().getFullYear();
  const { user } = useUser();

  const divisionFactor =
    client.liveSettings.monthlyYearly === "monthly" ? 12 : 1;

  const baseSpending = getSpendingItemOverYears(
    client.people,
    spending,
    settings,
    currentYear,
    currentYear + settings.maxYearsShown,
    "base",
  );
  const preSpending = spending.preSpending.map((item) =>
    getSpendingItemOverYears(
      client.people,
      spending,
      settings,
      currentYear,
      currentYear + settings.maxYearsShown,
      "pre",
      item.category,
    ),
  );

  const postSpending = spending.postSpending.map((item) =>
    getSpendingItemOverYears(
      client.people,
      spending,
      settings,
      currentYear,
      currentYear + settings.maxYearsShown,
      "post",
      item.category,
    ),
  );

  const years = yearRange(startYear, startYear + settings.maxYearsShown - 1);

  const calculateOne = (income: Income, currentYear: number) => {
    const result = calculate({
      people: client.people,
      income,
      currentYear,
      scenario: settings,
    });

    return {
      ...result,
      amount: result.amount / divisionFactor,
    };
  };
  const taxes = years.map((year) => ({
    name: "Taxes",
    year,
    amount:
      settings.incomes
        .filter((income) => income.enabled)
        .map((income) => calculateOne(income, year).amount)
        .filter((t) => typeof t === "number")
        .reduce((a, b) => a + b, 0) * getTaxRate(user, settings, year),
  }));

  return (
    <div className={`bg-white ${!print && "pb-5"}`}>
      <Header client={client as any} scenario={settings} page="Spending" />
      <SpendingChart
        years={yearRange(startYear, startYear + settings.maxYearsShown - 1)}
        spending={false}
        initialHeight={print ? 660 : 550}
        longevityFlag={user?.info?.longevityFlag}
        people={client.people}
        stability={!!user?.info?.stabilityRatioFlag}
        needsFlag={!!user?.info?.needsFlag}
        stackedData={[baseSpending, ...preSpending, ...postSpending, taxes].map(
          (item) => ({
            name: item[0]?.name,
            stable: true,
            values: item.map((i) =>
              i.name == "Taxes" ? i.amount : i.amount / divisionFactor,
            ),
          }),
        )}
      />
    </div>
  );
};

export default SpendChart;
